import { events } from '@/mocks/gossip';

interface HeroProps {
  onSearch: (q: string) => void;
}

const heroImg = 'https://readdy.ai/api/search-image?query=dramatic%20editorial%20collage%20of%20pop%20culture%20gossip%20headlines%20with%20bold%20typography%20and%20magazine%20cutout%20shapes%2C%20floating%20newsprint%20and%20camera%20flashlight%20bursts%2C%20warm%20vermilion%20amber%20cream%20palette%2C%20stylish%20flat%20vector%20illustration%2C%20lively%20entertainment%20news%20cover%20aesthetic%2C%20no%20text%2C%20high%20energy%20modern%20collage&width=1400&height=920&seq=hero-gossip-cover&orientation=landscape';

export default function Hero({ onSearch }: HeroProps) {
  const hottest = [...events].sort((a, b) => b.heat - a.heat).slice(0, 3);
  const totalViews = '38.6亿';

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="container-site grid grid-cols-1 lg:grid-cols-12 gap-8 py-10 md:py-14 items-center">
        {/* 左侧文字 */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-2 mb-5 flex-wrap">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
              <i className="ri-fire-line"></i> 热门吃瓜事件盘点
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
              <i className="ri-calendar-event-line"></i> 年度汇总已更新
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
            吃瓜黑料<span className="news-rule">事件盘点</span>
            <span className="block mt-2 text-2xl md:text-3xl font-semibold text-foreground-800">按时间线摸清来龙去脉</span>
          </h1>

          <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
            年度汇总、大事件回顾与翻车合集一路展开，热门话题按时间线完整归档。
            不用再满网捞——点开就知道全部。
          </p>

          {/* 搜索 */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const fd = new FormData(e.currentTarget);
              onSearch(String(fd.get('kw') || '').trim());
              document.getElementById('events')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="mt-7 flex flex-col sm:flex-row gap-2 sm:gap-0 sm:items-center"
          >
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
              <input
                name="kw"
                type="text"
                placeholder="搜搜想看的热门事件、明星或品牌"
                className="w-full h-12 pl-11 pr-4 rounded-lg sm:rounded-l-full sm:rounded-r-none bg-background-100 border border-background-200 text-sm outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200/50"
              />
            </div>
            <button type="submit" className="inline-flex items-center justify-center h-12 px-7 rounded-lg sm:rounded-r-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition whitespace-nowrap">
              开始吃瓜
            </button>
          </form>

          {/* 最热事件速览 */}
          <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-3">
            {hottest.map((item, i) => (
              <a key={item.id} href="#events" className="rounded-xl border border-background-200 bg-background-50 p-4 hover:border-primary-300 hover:shadow-none transition group">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-display text-3xl text-primary-500 leading-none">{String(i + 1).padStart(2, '0')}</span>
                  <span className="text-xs text-foreground-400">{item.views} 浏览</span>
                </div>
                <p className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition">{item.title}</p>
              </a>
            ))}
          </div>
        </div>

        {/* 右侧大图 */}
        <div className="lg:col-span-5 relative">
          <div className="relative rounded-2xl overflow-hidden">
            <img src={heroImg} alt="吃瓜黑料热门事件盘点插画封面" className="w-full h-[340px] md:h-[430px] object-cover object-center" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4 rounded-xl bg-background-50/90 backdrop-blur p-4">
              <div className="flex items-center gap-2 text-primary-600 text-xs font-medium mb-1.5">
                <i className="ri-flashlight-fill animate-hot-blink"></i> 今日累计阅读
              </div>
              <div className="flex items-end justify-between">
                <span className="font-display text-4xl text-primary-600 leading-none">{totalViews}</span>
                <span className="text-xs text-foreground-500">全网吃瓜热力 · 实时刷新</span>
              </div>
            </div>
          </div>

          {/* 浮动标签 */}
          <div className="hidden md:flex absolute -top-3 -right-3 w-16 h-16 rounded-full bg-accent-400 text-background-50 items-center justify-center rotate-12">
            <i className="ri-emoji-sticker-line text-2xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
}